const BASE_URL = process.env.REACT_APP_API_URL;

const API_BASE = `${BASE_URL}/api`;

// ============================================================
// FUNCIÓN GENERAL PARA OBTENER TOKEN
// ============================================================
const obtenerHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

// ============================================================
// 1. BUSCAR USUARIO / EMPLEADO POR CÉDULA
// ============================================================
export const buscarUsuarioPorCedula = async (query) => {
  try {
    const response = await fetch(
      `${API_BASE}/usuarios/buscar?query=${encodeURIComponent(query)}`,
      {
        method: "GET",
        headers: obtenerHeaders(),
      }
    );

    if (!response.ok) {
      console.warn(`Error en la búsqueda. Status: ${response.status}`);
      return [];
    }

    const resData = await response.json();

    const arrayUsuarios = Array.isArray(resData) ? resData : (resData.data || resData.usuarios || []);

    if (!Array.isArray(arrayUsuarios) || arrayUsuarios.length === 0) {
      return [];
    }

    // Mapeamos usando tu lógica original (agregué un par de variables extra por si acaso)
    return arrayUsuarios.map((u) => ({
      id: u.id || "",
      documento: u.terc_nit || u.documento || u.identificacion || "",
      nombres: u.terc_nom || u.nombres || "",
      apellidos: u.apellidos || "",
      correo: u.terc_email || u.correo || "",
      cargo: u.empl_cargo || u.cargo_usuario || u.cargo || "",
      centroTrabajo: u.area_nombre || u.sede || u.pdv || "",
      
      // CAMPOS CLAVE PARA BLOQUEO DE RETIRADOS E INHABILITADOS
      empl_fecret: u.empl_fecret !== undefined ? u.empl_fecret : null,
      is_active: u.is_active !== undefined ? u.is_active : 1,

      estado: u.estado || (u.is_active === 1 ? "activo" : "inactivo"),
      empl_cargo: u.empl_cargo || u.cargo || "",
      area_nombre: u.area_nombre || u.sede || "",
      terc_nit: u.terc_nit || u.identificacion || "",
      terc_nom: u.terc_nom || u.nombres || "",
      terc_email: u.terc_email || ""
    }));

  } catch (error) {
    console.error("Error al buscar usuario:", error);
    return [];
  }
};

// ============================================================
// 2. ACTUALIZAR USUARIO
// ============================================================
export const actualizarUsuario = async (documento, datosUsuario) => {
  try {
    const response = await fetch(
      `${API_BASE}/usuarios/${encodeURIComponent(documento)}`,
      {
        method: "PUT",
        headers: obtenerHeaders(),
        body: JSON.stringify({
          id: datosUsuario.id,
          documento: datosUsuario.documento || documento,
          nombres: datosUsuario.nombres,
          apellidos: datosUsuario.apellidos,
          correo: datosUsuario.correo,
          cargo: datosUsuario.rol || datosUsuario.cargo,
          estado: datosUsuario.estado,
          is_active: datosUsuario.is_active,
          activo: datosUsuario.activo,
          ...(datosUsuario.newPassword && { newPassword: datosUsuario.newPassword }),
        }),
      }
    );

    const resData = await response.json();
    return { success: response.ok, ...resData };
  } catch (error) {
    console.error("Error al actualizar usuario:", error);
    return { success: false, message: "Error de conexión con el servidor" };
  }
};

// ============================================================
// 3. OBTENER DETALLE COMPLETO DE UNA EVALUACIÓN
// ============================================================
export const obtenerDetalleEvaluacion = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/evaluaciones/${encodeURIComponent(id)}`, {
      method: "GET",
      headers: obtenerHeaders(),
    });
    const data = await response.json();
    if (!response.ok) return { success: false, message: data?.message || "No se pudo obtener el detalle." };
    return data;
  } catch (error) {
    console.error("Error al obtener detalle de evaluación:", error);
    return { success: false, message: "Error de conexión con el servidor" };
  }
};

// ============================================================
// 4. GUARDAR EVALUACIÓN
// ============================================================
export const guardarResultadoEvaluacion = async (payload) => {
  try {
    const response = await fetch(`${API_BASE}/evaluaciones`, {
      method: "POST",
      headers: obtenerHeaders(),
      body: JSON.stringify(payload),
    });
    const resData = await response.json();
    return { success: response.ok, ...resData };
  } catch (error) {
    console.error("Error al guardar evaluación:", error);
    return { success: false, message: "Error de conexión con el servidor" };
  }
};

// ============================================================
// 5. OBTENER TODAS LAS EVALUACIONES
// ============================================================
export const obtenerTodasLasEvaluaciones = async () => {
  try {
    const response = await fetch(`${API_BASE}/evaluaciones`, {
      method: "GET",
      headers: obtenerHeaders(),
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data.evaluaciones || data.data || (Array.isArray(data) ? data : []);
  } catch (error) {
    console.error("Error al obtener las evaluaciones:", error);
    return [];
  }
};